export default __webpack_public_path__ + "static/media/memorial.9e592d9a.png";